import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ThemeProvider } from '@ui5/webcomponents-react'
import axios from 'axios';

//change this to point to the api endpoint
axios.defaults.baseURL = process.env.REACT_APP_API_URL

const rootElement = document.getElementById('root')
if (!window.__reactRoot) {
  window.__reactRoot = ReactDOM.createRoot(rootElement)
}
if (!window.__queryClient) {
  window.__queryClient = new QueryClient()
}
const root = window.__reactRoot
const client = window.__queryClient

root.render(
  <React.StrictMode>
    <QueryClientProvider client={client}>
      <ThemeProvider>
        <App />
      </ThemeProvider>  
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
